import React from 'react';
import { RiSettings3Line } from '@remixicon/react';
import {
  type IconComponent,
  createFrontendModule,
  PageBlueprint,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';

export const settingsPagesModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/settings',
        routeRef: userSettingsPlugin.routes.root,
        title: 'Settings',
        loader: () =>
          import('./settings.page').then(m =>
            React.createElement(m.SettingsPage),
          ),
      },
    }),
    NavItemBlueprint.make({
      params: {
        title: 'Settings',
        icon: RiSettings3Line as IconComponent,
        routeRef: userSettingsPlugin.routes.root,
      },
    }),
  ],
});
